<template>
  <deferred-render-frame
    v-slot="{ currentFrame, maxFrameAchieved }"
    :max-frame="framesForRenderAll"
  >
    <div>
      <template v-for="(card, index) in cardNum">
        <div
          v-if="isReadyToRender(currentFrame, index) || maxFrameAchieved"
          :key="index"
          :class="{ 'mb-4': index !== cardNum - 1 }"
        >
          <slot />
        </div>
      </template>
    </div>
  </deferred-render-frame>
</template>

<script>
import DeferredRenderFrame from 'www/vue_components/common/DeferredRenderFrame/DeferredRenderFrame.vue'

export default {
  name: 'CardList',
  components: {
    DeferredRenderFrame,
  },
  props: {
    cardNum: {
      type: Number,
      default: 1,
    },
    renderBy: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      frameNum: 0,
    }
  },
  computed: {
    framesForRenderAll() {
      return Math.ceil(this.cardNum / this.renderBy)
    },
  },
  methods: {
    isReadyToRender(currentFrame, iteration) {
      return currentFrame * this.renderBy > iteration
    },
  },
}
</script>
